import { getCollapsiblePanelStyles } from '../../shared/styles/collapsible-panel';

export const getStyles = (components, theme) => ({
  divider: {
    padding: '5px 0px 0px 4px',
    width: '100%',
    borderTop: '2px solid #E0E0E0',
    marginTop: 30,
    marginBottom: 20,
  },
  budgetContainer: {
    '& .budget-title-container span': {
      fontWeight: 600,
    },
  },
  budgetBidShell: {
    display: 'flex',
    width: 966,
    '& .checkbox-inline, & .checkbox>label, & .radio-inline, & .radio>label, & label.checkbox, & label.radio': {
      '&:focus-within': {
        outline: 'none',
      },
    },
    '& .bid-and-budget #currencyLabelCostPerSale': {
      display: 'inline',
    },
  },
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
});
